import { gsap } from "gsap";
import { CustomEase, ScrollTrigger, ScrollToPlugin } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, CustomEase);

const heroTL = gsap.timeline();
const header = document.querySelector("header");

CustomEase.create(
  "custom-1",
  "0, 0.2, 0.4, 1"
);

if (header) {
   // Hero Heading
   const heroHeading = document.querySelector("#hero-heading");
   if (heroHeading) {
      const headingParts = heroHeading.innerText.split("\n");
      heroHeading.innerHTML = "";
      
      headingParts.forEach(part => {
         if (part.length > 0) {
            const span = document.createElement("span");
            span.innerText = part.replace("<br>", "").trim();
            heroHeading.appendChild(span)
         }
      });
      
      // Heading Animation
      heroTL.from("#hero-heading span", {
         yPercent: 75,
         opacity: 0,
         stagger: 0.25,
         duration: 0.25,
         ease: "expo"
      })
   }
   
   // Hero Background
   heroTL.fromTo("#hero-bg", {
      width: "100%",
      yPercent: -25,
      y: 0,
      x: "-50%",
      borderRadius: 0
   }, {
      width: "calc(100% - 32px)",
      yPercent: 0,
      y: "1rem",
      x: "-50%",
      borderRadius: window.matchMedia('(max-width: 767px)').matches ? "2rem" : "1rem",
      ease: "slow",
      duration: 1.5
   })
   
   // Hero Sub-Heading
   heroTL.fromTo("#hero-text", {
      y: "60vh",
   }, {
      y: 0,
      ease: "expo",
      duration: 1.5
   }, "<")
   
   // Hero CTA
   heroTL.from("#hero-cta", {
      y: "60vh",
      opacity: 0,
      ease: "expo",
      duration: 1.875,
   }, "<")
   
   // Pattern
   heroTL.from("#hero-pattern-left", {
      y: "60vh",
      x: "-50vw",
      ease: "custom-1",
      duration: 0.75,
   })
   heroTL.from("#hero-pattern-right", {
      y: "60vh",
      x: "50vw",
      ease: "custom-1",
      duration: 0.75
   }, "<")
   heroTL.from("#hero-pattern-bottom", {
      y: "50vh",
      opacity: 0,
      x: -100,
      ease: "custom-1",
      duration: 0.75
   })
   
}

// Navbar
const nav = document.querySelector('#nav')
if (nav) {
   heroTL.from(nav, {
      yPercent: -150,
      ease: "custom-1",
      duration: 0.75,
   }, "<")
}

// Inner Background
const backgroundAnimation = () => {
   let calcBgWidth = "calc(100% - 2rem)";
   let calcBgWidthLg;
   let borderRadius = "1rem";
   let borderRadiusLg = "3rem";
   
   // Adjust on Viewport
   const adjustWidth = () => {
      if (window.matchMedia('(max-width: 767px)').matches) {
         calcBgWidthLg = "calc(100% - 3rem)";
         calcBgWidth = "calc(100% - 3rem)";
         borderRadius = "2rem";
         borderRadiusLg = "1.5rem";
      } else if (window.matchMedia('(max-width: 1279px)').matches) {
         calcBgWidthLg = "calc(100% - 3rem)";
         borderRadiusLg = "1.5rem";
      } else if (window.matchMedia('(max-width: 1599px)').matches) {
         calcBgWidthLg = "calc(100% - 16rem)";
      } else {
         calcBgWidthLg = "calc(100% - 24rem)";
      }
   }
   adjustWidth();
   
   const innerBgLg = document.querySelectorAll('.bg-inner-lg');
   if (innerBgLg.length > 0) {
      innerBgLg.forEach(bg => {
         gsap.fromTo(bg, {
            width: "100%",
            height: "100%",
            borderRadius: "0",
         }, {
            width: calcBgWidthLg,
            height: "calc(100% - 6rem)",
            borderRadius: borderRadiusLg,
            ease: "power2.out",
            duration: 1,
            scrollTrigger: {
               trigger: bg,
               start: "top 50%",
               toggleActions: "play none none reverse"
            }
         })
      })
   }
   
   const innnerBg = document.querySelectorAll('.bg-inner');
   if (innnerBg.length > 0) {
      innnerBg.forEach(bg => {
         gsap.fromTo(bg, {
            width: "100%",
            borderRadius: "0",
         }, {
            width: calcBgWidth,
            borderRadius: borderRadius,
            ease: "power2.out",
            duration: 1,
            scrollTrigger: {
               trigger: bg,
               start: "top 60%",
               toggleActions: "play none none reverse"
            }
         })
      })
   }
}

backgroundAnimation();

// Feature Images
const featureImageLeft = document.querySelector('.feature-image-left');
const featureImageRight = document.querySelector('.feature-image-left');

if (featureImageLeft) {
   gsap.from(".feature-image-left", {
      y: -100,
      scale: "0.5",
      ease: "slow",
      duration: 1,
      delay: 0.5,
      scrollTrigger: {
         trigger: ".bg-inner-lg",
         start: "top 50%",
         toggleActions: "play none none reverse"
      }
   })
}

if (featureImageRight) {
   gsap.from(".feature-image-right", {
      x: "3rem",
      ease: "slow",
      duration: 1,
      scrollTrigger: {
         trigger: ".bg-inner-lg",
         start: "top 50%",
         toggleActions: "play none none reverse"
      }
   })
}

const circleProgress = document.querySelectorAll('.circle-progress');

if (circleProgress.length > 0) {
   circleProgress.forEach(circle => {
      const path = circle.querySelector('path');
      const toValue = `${circle.getAttribute('percent')*2.85},250.2`;
      gsap.fromTo(path, {
         strokeDasharray: "0,250.2",
         opacity: 0
      }, {
         strokeDasharray: toValue,
         opacity: 1,
         duration: 1,
         ease: "power2.out",
         scrollTrigger: {
            trigger: circle,
            toggleActions: "play none none reverse",
            start: "top 70%"
         }
      })

   })
}
const animatesLines = document.querySelectorAll('.animated-lines');

if (animatesLines.length > 0) {
   animatesLines.forEach(innerLine => {
      const line = innerLine.querySelectorAll('.line');
      
      gsap.from(line, {
         height: 0,
         ease: "power2.out",
         stagger: 0.1,
         duration: 0.1,
         scrollTrigger: {
            trigger: line,
            toggleActions: "play none none reverse",
            start: "top 80%"
         }
      })

   })
}

// Logo Animation
const marqueeConatiner = document.querySelector('.marquee');
let marquee;
if (marqueeConatiner) {
   const marqueeContent = marqueeConatiner.children[0];
   const contentWidth = marqueeContent.offsetWidth;

   marquee = gsap.to(marqueeConatiner.children, {
      x: -contentWidth,
      duration: 40,
      ease: "linear",
      repeat: -1,
      onRepeat: function () {
         gsap.set(marqueeContent, { x: 0 });
      },
   });

   // Pause animation on mouse hover and resume when the cursor leaves
   marqueeConatiner.addEventListener('mouseenter', () => {
      marquee.pause();
   });
   marqueeConatiner.addEventListener('mouseleave', () => {
      marquee.play();1
   });
}